export default {
    IS_DEVELOPMENT : true,
    ONESIGNAL_APP_ID: "4f72ea09-f362-4873-b099-d27c2bea4a31",
    PWA_DISABLED: __PWA_DISABLED__,
}
